module.exports = __webpack_public_path__ + "static/img/噜咔博士AI拍学机.3a0d8505.png";